import Vue3Signature from 'vue3-signature'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()

  // @ts-ignore - typescript complains but this seems to work fine
  nuxtApp.vueApp.use(Vue3Signature)
})
